import { Container } from '@/atoms';
import { TabGroup } from '@/molecules';

import { blockSpacing, sectionBgProps } from '@/utils';

/**
 * ComponentRevisadasTabs
 */
export const ComponentRevisadasTabs = ({
  Link,
  FondoSeccion,
  Color,
  Espaciado,
}: any) =>
  Link?.length > 0 ? (
    <Container
      wrapper
      className={blockSpacing(Espaciado, '')}
      {...sectionBgProps(FondoSeccion)}
    >
      <TabGroup
        color={Color}
        tabsgroups={Link.map((itm: any) => ({
          href: itm.Link,
          label: itm.Titulo,
        }))}
      />
    </Container>
  ) : null;

ComponentRevisadasTabs.displayName = 'ComponentRevisadasTabs';
